// 1. Import `extendTheme`
import {extendTheme} from '@chakra-ui/react';

// 2. Call `extendTheme` and pass your custom values
const theme = extendTheme({
    fontSizes: {
        xxs: '0.6rem'
    },
    components: {
        Button: {
            baseStyle: {
                boxShadow: 'base',
                borderRadius: '2',
                _focus: {
                    boxShadow: 'none'
                }
            },
            sizes: {
                sm: {
                    px: 6
                },
                md: {
                    px: 10
                }
            }
        },
        Tabs: {
            baseStyle: {
                tab: {
                    _focus: {
                        boxShadow: 'none'
                    }
                }
            }
        }
    }
});

export default theme;
